import api from '../../api/axios';
import { showError } from '../../Components/reuse/Toast';

// Action Types
export const GET_CONVERSATIONS_REQUEST = 'GET_CONVERSATIONS_REQUEST';
export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS';
export const GET_CONVERSATIONS_FAILURE = 'GET_CONVERSATIONS_FAILURE';

// New: Conversation list (page/limit) types
export const GET_CONVERSATION_LIST_REQUEST = 'GET_CONVERSATION_LIST_REQUEST';
export const GET_CONVERSATION_LIST_SUCCESS = 'GET_CONVERSATION_LIST_SUCCESS';
export const GET_CONVERSATION_LIST_FAILURE = 'GET_CONVERSATION_LIST_FAILURE';

export const GET_CONVERSATION_DETAILS_REQUEST = 'GET_CONVERSATION_DETAILS_REQUEST';
export const GET_CONVERSATION_DETAILS_SUCCESS = 'GET_CONVERSATION_DETAILS_SUCCESS';
export const GET_CONVERSATION_DETAILS_FAILURE = 'GET_CONVERSATION_DETAILS_FAILURE';

// Get conversations
export const getConversations = (agentId, limit = 10, nextCursor = null) => async (dispatch) => {
  const append = Boolean(nextCursor);
  dispatch({ type: GET_CONVERSATIONS_REQUEST, meta: { append } });
  try {
    const payload = {
      agentId: agentId,
      limit: limit
    };
    
    if (nextCursor) {
      payload.nextCursor = nextCursor;
    }

    const response = await api.post('conversations/getConversations', payload);
    if (response.data.success) {
      dispatch({ type: GET_CONVERSATIONS_SUCCESS, payload: response.data, meta: { append } });
    } else {
      dispatch({ type: GET_CONVERSATIONS_FAILURE, error: response.data.message || 'Failed to fetch conversations', meta: { append } });
      showError(response.data.message || 'Failed to fetch conversations');
    }
  } catch (error) {
    console.error('Failed to fetch conversations:', error);
    dispatch({ type: GET_CONVERSATIONS_FAILURE, error: 'Failed to fetch conversations', meta: { append } });
    showError('Failed to fetch conversations');
  }
};

// New: Get conversations via page/limit list API
export const getConversationList = (limit = 50, page = 1, filters = {}) => async (dispatch) => {
  const append = page > 1;
  dispatch({ type: GET_CONVERSATION_LIST_REQUEST, meta: { append } });
  try {
    const params = { 
      limit, 
      page,
      ...filters
    };
    
    // Convert date objects to ISO strings if they exist
    if (filters.fromDate) {
      params.fromDate = filters.fromDate instanceof Date ? filters.fromDate.toISOString() : filters.fromDate;
    }
    if (filters.toDate) {
      params.toDate = filters.toDate instanceof Date ? filters.toDate.toISOString() : filters.toDate;
    }
    
    const response = await api.get('conversations/getConversationList', {
      params
    });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_CONVERSATION_LIST_SUCCESS, payload: response.data, meta: { append, limit, page } });
    } else {
      const message = response?.data?.message || 'Failed to fetch conversation list';
      dispatch({ type: GET_CONVERSATION_LIST_FAILURE, error: message, meta: { append } });
      showError(message);
    }
  } catch (error) {
    console.error('Failed to fetch conversation list:', error);
    dispatch({ type: GET_CONVERSATION_LIST_FAILURE, error: 'Failed to fetch conversation list', meta: { append } });
    showError(error.response.data.message || 'Failed to fetch conversation list');
  }
};

// Get conversation details
export const getConversationDetails = (conversationId) => async (dispatch) => {
  dispatch({ type: GET_CONVERSATION_DETAILS_REQUEST });
  try {
    const payload = {
      conversationId: conversationId
    };

    const response = await api.post('conversations/getConversationDetails', payload);
    if (response.data.success) {
      dispatch({ type: GET_CONVERSATION_DETAILS_SUCCESS, payload: response.data.data });
    } else {
      dispatch({ type: GET_CONVERSATION_DETAILS_FAILURE, error: response.data.message || 'Failed to fetch conversation details' });
      showError(response.data.message || 'Failed to fetch conversation details');
    }
  } catch (error) {
    console.error('Failed to fetch conversation details:', error);
    dispatch({ type: GET_CONVERSATION_DETAILS_FAILURE, error: 'Failed to fetch conversation details' });
    showError(error.response.data.message || 'Failed to fetch conversation details');
  }
};
